

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styles from './MenuIcon.css';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { SetMobileMenu, SetModalVisible } from '../../actions';
import withStyles from '../../decorators/withStyles';


class MenuIcon extends Component {

  static propTypes = {
    menuOpen: PropTypes.bool.isRequired,
    modalVisible: PropTypes.bool.isRequired,
  };

  handleClick = e => {
    if (this.props.modalVisible) {
      this.props.dispatch(SetModalVisible(false));
    } else if (this.props.menuOpen) {
      this.props.dispatch(SetMobileMenu(false));
    } else {
      this.props.dispatch(SetMobileMenu(true));
    }
  };

  render() {
    return (
      <div className="MenuIcon" onClick={this.handleClick}>
        <button id="collapsed-menu-btn"
                className={!(this.props.menuOpen || this.props.modalVisible) ? "small-screen nav-btn circled" : "small-screen nav-btn circled hidden"}>
          <span className="icon menu"></span>
        </button>
        <button id="small-screen-back"
                className={(this.props.menuOpen || this.props.modalVisible) ? "small-screen nav-btn circled" : "small-screen nav-btn circled hidden"}>
          <span className="icon left-arrow"></span>
        </button>
      </div>);
  };

}

export default compose(
  withStyles(styles),
  connect((state) => {return {};}),
)(MenuIcon);
